import useUser from "../../../../../core/hooks/use-user";
import { toast } from "../../../../../core/helpers/message-helper";
import Datatable from "../../../../../core/ui/components/Datatable";
import { API_URL } from "../../../../../core/config/env";
import ContentWrapper from "../../../../../core/ui/components/Layout/ContentWrapper";

const SolicitudesEnProcesoGH = () => {
    const { getAccessToken } = useUser();
    const token = getAccessToken();


    let tableButtons = [];

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "solicitudes",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ]

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaSolicitudesEnProcesoGH",
        buttons: tableButtons,
        select: {
            style: "single",
        },
        ajax: {
            url: `${API_URL}/solicitudesGH/solicitudesEnProceso`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error al obtener el listado de las solicitudes en proceso Gestión Humana"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "asunto" },
            { data: "descripcion" },
            { data: "persona_id" },
            { data: "nombre_lugar_id" },
            { data: "adjunto" },
            { data: "parametro_tipo_solicitud_id" },
            { data: "parametro_estado_solicitud_id" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [8],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    MESA DE AYUDA / GESTIÓN HUMANA / Solicitudes En Proceso
                </div>
            </div>
            <Datatable options={dtOptions} >
                <table
                        className="w-100 table table-hover"
                        id="tablaSolicitudesEnProcesoGH">
                    <thead className="bg-dark">
                        <tr>
                            <th className="text-center text-white">Id</th>
                            <th className="text-center text-white">Asunto</th>
                            <th className="text-center text-white">Descripcion</th>
                            <th className="text-center text-white">Persona</th>
                            <th className="text-center text-white">Lugar</th>
                            <th className="text-center text-white">Adjunto</th>
                            <th className="text-center text-white">Tipo solicitud</th>
                            <th className="text-center text-white">Estado solicitud</th>
                            <th className="text-center text-white">Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
        </ContentWrapper>
    );
};

export default SolicitudesEnProcesoGH;
